import React, { useState } from "react";
import LineChart from "./LineChart";

const AccumulationChart = ({
	task,
	openSprintTaskDetails,
	closeChart,
	colourBlindMode,
}) => {
	const getBackgroundColor = (colourBlindMode) => {
		switch (colourBlindMode) {
			case true:
				return "#C96514";
			default:
				return "#FF3528";
		}
	};

	const [userData, setUserData] = useState({
		labels: task.sprintLogTime
			.sort((a, b) => {
				const dateA = new Date(a.day);
				const dateB = new Date(b.day);
				return dateA - dateB;
			})
			.map((data) => data.day),
		datasets: [
			{
				label: task.taskAssignee,
				data: task.accumData,
				borderColor: getBackgroundColor(colourBlindMode),
				backgroundColor: getBackgroundColor(colourBlindMode),
			},
		],
	});

	const options = {
		plugins: {
			legend: {
				position: "top",
			},
			title: {
				display: true,
				text: task.taskName,
			},
		},
		scales: {
			x: {
				title: {
					display: true,
					text: "Date",
				},
			},
			y: {
				title: {
					display: true,
					text: "Hours",
				},
			},
		},
	};

	const back = () => {
		closeChart();
		openSprintTaskDetails(task);
	};

	return (
		<div className="block fixed z-[1] w-full h-full overflow-auto bg-[rgba(0,0,0,0.649)] left-0 top-0">
			{/* modal content */}
			<div className="flex justify-center items-center mt-[25vh] ml-[60vh] w-[1250px]">
				<div className="text-[#ffffff] w-5/12 h-auto bg-[#3D3E44] rounded-xl">
					{/* Header for Form */}
					<div className="bg-[#9B9B9B] rounded-t-xl py-3 text-3xl text-center">
						Sprint Task
					</div>
					{/* Buttons */}
					<div className="bg-modalbg w-full">
						<div className="flex justify-between mt-[5px]">
							<div className="pl-[10px] space-x-[10px]">
								<button
									className="bg-modalbg text-[10px] text-[#89898A]"
									onClick={back}
								>
									<i class="fa-solid fa-arrow-left mr-[5px]"></i>
									Task details
								</button>
							</div>

							<div className="pr-[10px] space-x-[10px] flex items-center">
								<button className="bg-modalbg text-[10px] text-[#89898A]">
									Accumulation Chart
									<i class="fa-solid fa-arrow-right ml-[5px]"></i>
								</button>
							</div>
						</div>
					</div>

					<div className="bg-modalbg flex mt-[20px] justify-center text-[#89898A]">
						Accumulation Effort Chart of {task.taskName}
					</div>
					<div className="bg-modalbg flex mt-[20px] justify-center">
						<div className="bg-[#E1DFDF] h-[300px] w-full mr-[15px] ml-[15px]">
							<LineChart chartData={userData} labels={options} />
						</div>
					</div>
					<div className="flex mt-[50px] justify-center mb-[20px]">
						<button
							className="bg-[#616675] pl-[12px] pr-[12px]"
							onClick={closeChart}
						>
							CLOSE
						</button>
					</div>
					{/* Rest of your component content */}
				</div>
			</div>
		</div>
	);
};

export default AccumulationChart;
